import React from 'react';
import { IonCol, IonRow, IonText, IonButton, IonAccordion, IonAccordionGroup, IonItem, IonLabel } from '@ionic/react';
import { MobileCards, GridTable } from '../ReportRenderers';

const TENANT_STATMENT = "Tenant Statement";
const PROPERTY_STATEMENT = "Property Statement";

const StepResults = ({
    canSubmit,
    invalidMessage,
    validationError,
    onView,
    onDownloadPdf,
    onDownloadExcel,
    statementType,
    propertyId,
    propertyIds,
    propertyName,
    propertyTables,
    multiPropertyData,
    tableData,
    columns,
    colorTheme,
}) => {
    const isPropertyStatement = statementType === PROPERTY_STATEMENT;
    const hasPropertySelection = Array.isArray(propertyIds) && propertyIds.length > 0;
    const multiPropertyCount = multiPropertyData?.properties?.length || 0;

    const renderSection = (title, rows, cols, sectionKey) => (
        <div className="ion-margin-top">
            <div className="p-1">
                <h5 style={{ marginBottom: '8px' }}>{title}</h5>
                {sectionKey === 'tenants' ? (
                    <MobileCards rows={rows} cols={cols} sectionKey={sectionKey} />
                ) : (
                    <GridTable rows={rows} cols={cols} />
                )}
            </div>
        </div>
    );

    const renderPropertyTables = (tables, hideTenants = false) => (
        <div>
            {!hideTenants && tables?.tenants && renderSection('Tenants', tables.tenants.rows, tables.tenants.cols, 'tenants')}
            {tables?.expenses && renderSection('Expenses', tables.expenses.rows, tables.expenses.cols, 'expenses')}
            {tables?.nonPropertyExpenses && renderSection(
                'Expenses not linked to a property',
                tables.nonPropertyExpenses.rows,
                tables.nonPropertyExpenses.cols,
                'nonPropertyExpenses'
            )}
            {tables?.summary && renderSection('Summary', tables.summary.rows, tables.summary.cols, 'summary')}
            {tables?.occupancy && renderSection('Occupancy', tables.occupancy.rows, tables.occupancy.cols, 'occupancy')}
        </div>
    );

    return (
        <div>
            <div>
                <IonRow className="ion-justify-content-center ion-align-items-center">
                    <IonCol size="12" sizeMd="auto" className="ion-text-center">
                        <IonButton expand="block" color="primary" onClick={onView} disabled={!canSubmit} style={{ backgroundColor: colorTheme.primary[700] }}>View</IonButton>
                    </IonCol>
                    <IonCol size="12" sizeMd="auto" className="ion-text-center">
                        <IonButton expand="block" fill="outline" onClick={onDownloadPdf} disabled={!canSubmit}>Download PDF</IonButton>
                    </IonCol>
                    <IonCol size="12" sizeMd="auto" className="ion-text-center">
                        <IonButton expand="block" fill="outline" onClick={onDownloadExcel} disabled={!canSubmit}>Download Excel</IonButton>
                    </IonCol>
                </IonRow>
                {(!canSubmit || validationError) && (
                    <div className="ion-margin-top">
                        <IonText color="danger">{!canSubmit ? invalidMessage : validationError}</IonText>
                    </div>
                )}

                {isPropertyStatement ? (
                    <div className="ion-margin-top">
                        <IonText>
                            <h4 style={{ marginBottom: '8px' }}>{statementType}</h4>
                        </IonText>
                        {hasPropertySelection && propertyTables && (
                            <IonAccordionGroup>
                                <IonAccordion value={propertyId || 'property'}>
                                    <IonItem slot="header">
                                        <IonLabel>{propertyName || 'Property'}</IonLabel>
                                    </IonItem>
                                    <div className="ion-padding-bottom ion-padding-start ion-padding-end" slot="content">
                                        {renderPropertyTables(propertyTables)}
                                    </div>
                                </IonAccordion>
                            </IonAccordionGroup>
                        )}
                        {hasPropertySelection && multiPropertyData && (
                            <IonAccordionGroup>
                                {multiPropertyCount > 1 && (
                                    <IonAccordion value="overall-summary">
                                        <IonItem slot="header">
                                            <IonLabel>Overall Summary</IonLabel>
                                        </IonItem>
                                        <div className="ion-padding-bottom ion-padding-start ion-padding-end" slot="content">
                                            {renderPropertyTables(multiPropertyData.overall, true)}
                                        </div>
                                    </IonAccordion>
                                )}
                                {(multiPropertyData.properties || []).map((prop) => (
                                    <IonAccordion key={prop.propertyId} value={prop.propertyId}>
                                        <IonItem slot="header">
                                            <IonLabel>{prop.propertyName || 'Property'}</IonLabel>
                                        </IonItem>
                                        <div className="ion-padding-bottom ion-padding-start ion-padding-end" slot="content">
                                            {renderPropertyTables(prop.tables)}
                                        </div>
                                    </IonAccordion>
                                ))}
                            </IonAccordionGroup>
                        )}
                    </div>
                ) : (
                    propertyTables ? (
                        <div>
                            {renderPropertyTables(propertyTables)}
                        </div>
                    ) : (
                        tableData && tableData.length > 0 && (
                            <div className="ion-margin-top">
                                <div className='p-1'>
                                    <MobileCards rows={tableData} cols={columns} sectionKey='generic' />
                                </div>
                            </div>
                        )
                    )
                )}
            </div>
        </div>
    );
};

export default StepResults;


